// !! Important !!
// This should be the very first import in this file, to ensure that the LogRocket gets
// initialized and starts logging immediately, before anything else happens (error or otherwise)
import './features/zLogRocket/initialize'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import ProviderWrapper from './components/provider/ProviderWrapper'
import initApp from './initApp'
import './features/userPilot/userpilot.bootstap'
import {
  handleSessionPersistenceEnabled,
  isSessionPersistenceEnabled,
  preloadSessionPersistData,
} from './features/session/persist/utils/sessionPersist.util'

export const store = initApp()

const bootstrap = async () => {
  if (isSessionPersistenceEnabled()) {
    const canProceedWithPersistedSession = await handleSessionPersistenceEnabled()
    if (!canProceedWithPersistedSession) {
      return
    }
  }

  await preloadSessionPersistData(store)
  ReactDOM.render(
    <ProviderWrapper store={store}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </ProviderWrapper>,
    document.getElementById('root')
  )
}

bootstrap()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (process.env.NODE_ENV === 'development') {
  serviceWorkerRegistration.unregister()
} else {
  serviceWorkerRegistration.register({
    onUpdate: async (registration: ServiceWorkerRegistration) => {
      await registration.update()
    },
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.NODE_ENV === 'development') {
  reportWebVitals()
}
